<template>
    <div class="form-type-0">

        <form @submit.prevent="updateNotificationSettings" @input="onInputChange" ref="form" novalidate>
            <CustomSelect
                v-model="email_interval"
                inputKey="options_notifications_interval"
                ref="interval"
                :options="intervalOptions"
            />
            <CustomSelect
                v-model="email_filter"
                inputKey="options_notifications_filter"
                ref="filter"
                :options="filterOptions"
                :disabled="email_interval === '-1' || email_interval === -1"
            />
            <button v-if="!hideSaveButton || hasChanged" type="submit" :disabled="loading">
                <span v-if="loading" class="loading-spinner-type-1"></span>
                <span v-else>{{ $t('forms.account_notifications.button') }}</span>
            </button>
            <p v-if="formError" class="form-error">{{ $t('forms.account_notifications.error') }}</p>
            <p v-if="formSuccess" class="form-success">{{ $t('forms.account_notifications.success') }}</p>
        </form>
    </div>
</template>

<script>
    import { useAccountStore } from '@/stores/account';
    import { useUsersStore } from '@/stores/users';
    import CustomSelect from '@/components/elements/inputs/CustomSelect';
    import formMixin from '@/mixins/formMixin';

    export default {
        mixins: [formMixin],
        props: {
            hideSaveButton: {
                type: Boolean,
                default: false
            },
            user: {
                type: Object,
                required: true
            }
        },
        components: {
            CustomSelect
        },
        data() {
            return {
                email_interval: -1,
                email_filter: 0,
                intervalOptions: [
                    { value: -1, text: 'fields.options_notifications_interval.options.-1' },
                    { value: 1, text: 'fields.options_notifications_interval.options.1' },
                    { value: 7, text: 'fields.options_notifications_interval.options.7' },
                ],
                filterOptions: [
                    { value: 0, text: 'fields.options_notifications_filter.options.no' },
                    { value: 1, text: 'fields.options_notifications_filter.options.1' },
                    { value: -2, text: 'fields.options_notifications_filter.options.-2' },
                ],
            };
        },
        computed: {
            accountStore() {
                return useAccountStore();
            },
            account() {
                return this.accountStore.account;
            },
            usersStore() {
                return useUsersStore();
            },
        },
        methods: {
            async updateNotificationSettings() {

                const form = this.$refs.form;
                if(form.checkValidity()) {
                    this.loading = true;
                    const success = await this.usersStore.updateUser({
                        account_id: this.account.account_id,
                        email: this.user.email,
                        email_interval: parseInt(this.email_interval, 10),
                        ...(this.email_interval !== '-1' && { email_weekday: 1 }),
                        ...(this.email_interval !== '-1' && { email_filter: parseInt(this.email_filter) })
                    });
                    this.loading = false;

                    if (success) {
                        this.formSuccess = true;
                        this.formError = false;
                        this.hasChanged = false;
                        this.$emit('form_submission_successful');

                    } else {
                        this.formSuccess = false;
                        this.formError = true;
                    }
                } else {
                    this.validateAllFields();
                }
            },
        },
        mounted() {
            if(this.user) {
                this.email_interval = this.user?.email_interval ?? -1;
                this.email_filter = this.user?.email_filter ?? 0;
            }
        },
        watch: {
            user(newUser) {
                this.email_interval = newUser?.email_interval ?? -1;
                this.email_filter = newUser?.email_filter ?? 0;
            }
        }
    }
</script>
